import { Injectable } from '@angular/core';
import { CcfacRange, Ccenter } from '../models';
import { GridCriteria } from '../models/grid-criteria';
import { utils as xlsUtils, WorkBook, WorkSheet, writeFile, } from 'xlsx-js-style';

@Injectable({
    providedIn: 'root',
})
export class CcenterFacultyExportService {

    private getCheckboxCriteria(checkboxCriteria: CcfacRange[] = []): string {
        if (checkboxCriteria == null) {
            return ''
        }
        let result = '';
        // sort the checkboxCriteria based on orgElementCode
        checkboxCriteria.sort((ccfac1, ccfac2) => ccfac1.orgElementCode.localeCompare(ccfac2.orgElementCode));
        checkboxCriteria.forEach(ccfac => {
            result += `${ccfac.orgElementCode} - ${ccfac.description}; `;
        });
        result = result ? result.slice(0, -2) : result;
        return result
    }

    exportToExcel(rows: any, orgUnitFilter: CcfacRange[] = [], ccenterFilter: GridCriteria, ccenterDescriptionFilter: GridCriteria) {
        const workBook = this.createWorkBook(rows, orgUnitFilter, ccenterFilter, ccenterDescriptionFilter);
        writeFile(workBook, 'CctrFaculty.xlsx');
    }

    private createWorkBook(rows: any, orgUnitFilter: CcfacRange[] = [], ccenterFilter: GridCriteria, ccenterDescriptionFilter: GridCriteria) {
        const workBook = xlsUtils.book_new()
        const aoa = this.createWorkbookAoA(rows, orgUnitFilter, ccenterFilter, ccenterDescriptionFilter);
        const sheet = xlsUtils.aoa_to_sheet(aoa);
        xlsUtils.book_append_sheet(workBook, sheet);
        return workBook;
    }

    private createWorkbookAoA(rows: any, orgUnitFilter: CcfacRange[] = [], ccenterFilter: GridCriteria, ccenterDescriptionFilter: GridCriteria): any[][] {
        const r = [];
        r.push([{ v: "Cost Center - Faculty", t: "s", s: { font: { bold: true, sz: 24 } } }]);

        r.push([{ v: "Org Unit:", t: "s", s: { font: { bold: true } } }, this.getCheckboxCriteria(orgUnitFilter)]);
        r.push([{ v: "Org Unit Description:", t: "s", s: { font: { bold: true } } }]);
        r.push([{ v: "Cost Center:", t: "s", s: { font: { bold: true } } }, ccenterFilter.getCriteriaDescription()]);
        r.push([{ v: "Cost Center Description:", t: "s", s: { font: { bold: true } } }, ccenterDescriptionFilter.getCriteriaDescription()]);
        r.push([]);
        r.push([]);
        r.push([{ v: "Org Unit", t: "s", s: { font: { bold: true } } },
        { v: "Org Unit Description", t: "s", s: { font: { bold: true } } },
        { v: "Cost Center", t: "s", s: { font: { bold: true } } },
            { v: "Cost Center Description", t: "s", s: { font: { bold: true } } },

        ]);
        if (rows.length > 0) {
            r.push(...rows.map(row => [row.orgElementCode, row.orgDescription, row.ccenterElementCode, row.ccenterDescription]))
        }
        return r;
    }
}